import * as React from 'react';
import 'twin.macro';

import { NavbarHomeTitleContent, ImpressionTextEl, ImpressionImage, TopImpressionLogoEl } from '@restworld/ui-ds';

import { AddressSearchBar } from '../../../job-explorer/address-search-bar';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IFrontViewImpressionWithSearchBarProps {}

export const DesktopFrontViewImpressionWithSearchBar: React.FunctionComponent<
  IFrontViewImpressionWithSearchBarProps
> = (props) => {
  return (
    <>
      <div tw="hidden lg:grid  grid-cols-7 gap-4 items-center pb-16.25">
        <div tw="grid col-span-4 flex-col gap-y-17.75 md:gap-9">
          <div tw="flex gap-9 md:gap-8 flex-col">
            <ImpressionTextEl>
              <NavbarHomeTitleContent />
            </ImpressionTextEl>
            <div tw="w-fit">
              <AddressSearchBar key="home-page" />
            </div>
          </div>
          <TopImpressionLogoEl />
        </div>
        <div tw="grid col-span-3 justify-center">
          <ImpressionImage />
        </div>
      </div>
    </>
  );
};
export default DesktopFrontViewImpressionWithSearchBar;
